import api from '../client'

// One leg search for every Studio product: Feed, Prepacks and Affiliate links
// all search GET /legs/search and get the same Prepacks leg back.
export const legSearchApi = {
  // Requests stay in the organization the page asked for, even if the selected
  // organization changes while one is in flight (same rule as prepacksApi).
  search: async (orgSlug, request, { signal } = {}) => {
    const params = {
      q: request.q,
      offering_id: request.offeringIds,
      sport: request.sport,
      event_status: request.eventStatus,
      limit: request.limit,
      cursor: request.cursor,
      search_session: request.searchSession,
      search_seq: request.searchSeq,
    }

    Object.keys(params).forEach((key) => {
      const value = params[key]
      if (value === undefined || value === null || value === '' || (Array.isArray(value) && value.length === 0)) {
        delete params[key]
      }
    })

    const response = await api.get(`/${orgSlug}/legs/search`, {
      params,
      paramsSerializer: { indexes: null },
      signal,
      _skipOrgRewrite: true,
    })
    return response.data
  },
}
